import WaterAnalysis from './Analysis'

export default {
    WaterAnalysis
}
